import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ApiService from '../api/ApiService.js'
import PageHeader from '../components/common/PageHeader.jsx'
import DonationCampaigns from '../components/donate/DonationCampaigns.jsx'
import GoToTop from '../helpers/GoToTop.js'
import MetaData from '../helpers/MetaData.js'

const Donate = () => {
  const [top, setTop] = useState(0)

  const [meta, setMeta] = useState(null)
    const fetchMeta = async (pagename) => {
        try {
            let res = await ApiService.fetchMetaData(pagename)
            setMeta(res)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchMeta('donate')
    }, [])

  return (
    <>
        <MetaData title="Donate - ISKCON of Bhiwandi" />
        <PageHeader title="Donate" imgSrc="/images/page-header/23.webp" />
        <DonationCampaigns setTop={setTop} />
        <GoToTop top={top} />
    </>
  )
}

export default Donate